import { Button, Divider } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSafeBackNavigation } from "../../../../shared/Route/useSafeBackNavigation";
import { PetProfileForm } from "./PetProfileForm";

export const CreatePetProfile = () => {
  const { navigate } = useSafeBackNavigation("/");

  return (
    <div className="space-y-6">
      <div  className="space-y-2">
        <div className="flex gap-4 items-start">
        <Button
          className="dark:!text-white dark:!bg-transparent  dark:hover:!bg-gray-600"
          type="default"
          icon={<ArrowLeftOutlined style={{ fontSize: 16 }} />}
          onClick={() => navigate("/profile/my-pets")}
        ></Button>

        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Create Pet Profile
        </h2>
        </div>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
         Create a profile for your pet by filling in the basic details below. This will help us provide personalized recommendations and a better experience for you and your furry friend.
        </p>
        <Divider />
      </div>

      <PetProfileForm mode={"create"} />
    </div>
  );
};
